import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=0fa37d4a"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=0fa37d4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports